// packages
import Swal from 'sweetalert2'

export const showLoading = (message: string) => {
  Swal.fire({
    title: 'Carregando ...',
    text: message,
    // icon: 'info',
    allowOutsideClick: false,
    allowEscapeKey: false,
    // allowEnterKey: false,
    didOpen: () => {
      Swal.showLoading()
    }
  })
}

export const closeLoading = () => {
  Swal.close() // Fecha o alerta manualmente
}

export const showError = (message: string) => {
  return Swal.fire({
    title: 'Ops ...',
    text: message,
    icon: 'error',
    confirmButtonColor: '#c4b638',
    customClass: 'bg-[#f8f9fa] text-black dark:text-white text-preline'
  })
}

export const showSuccess = (message: string) => {
  return Swal.fire({
    title: 'Sucesso',
    text: message,
    icon: 'success',
    customClass: 'bg-[#f8f9fa] text-black dark:text-white text-preline',
    confirmButtonColor: '#c4b638'
  })
}

export const showInfo = (message: string) => {
  return Swal.fire({
    title: 'Ops ...',
    text: message,
    icon: 'info',
    confirmButtonColor: '#c4b638',
    customClass: 'bg-secondary text-white dark:text-white text-preline'
  })
}

export const showConfirm = async (message: string) => {
  const [result] = await Promise.all([
    Swal.fire({
      title: 'Confirmar?',
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#c4b638',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      customClass: 'bg-[#f8f9fa] text-black dark:text-white text-preline',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true
    }),
    (document.body.style.pointerEvents = 'auto')
  ])

  return result
}

export const showWSMessage = async (title: string, message: string) => {
  const [result] = await Promise.all([
    Swal.fire({
      title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#c4b638',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      customClass: 'bg-[#f8f9fa] text-black dark:text-white text-preline',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true
    }),
    (document.body.style.pointerEvents = 'auto')
  ])

  return result
}
